export class UIDPrivacyPolicySceneController {
    hide() {
        this.privacyPolicySceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.privacyPolicySceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.privacyPolicySceneContainerDiv = document.getElementById('scene_discord_privacy_policy_container');
    }
}
